<!--Navbar-->
<header class="fixed-top" aria-label="Header">
  <!-- Add 'skip-body-focus' class in body tag when skip to main content button display -->
  <!-- <div class="skip-section">
		<a tabindex="-1" skipContent [elementId]="'dashboardLink'" class="btn skip-link" size="sm" color="light" pmdRipple pmd-btn-outline
			[attr.aria-label]="'LAYOUT.HOME.SKIP_TO_SIDE_BAR_LABEL' | translate" (focus)="skipContentFocusAdd()"
			(blur)="skipContentFocusRemove()">{{ 'LAYOUT.HOME.SKIP_TO_SIDE_BAR' | translate }}</a>
		<a tabindex="-1" skipContent [elementId]="'mainContent'" class="btn skip-link" size="sm" color="light" pmdRipple pmd-btn-outline
			[attr.aria-label]="'LAYOUT.HOME.SKIP_TO_MAIN_CONTENT_LABEL' | translate" (focus)="skipContentFocusAdd()"
			(blur)="skipContentFocusRemove()">{{ 'LAYOUT.HOME.SKIP_TO_MAIN_CONTENT' | translate }}</a>
	</div> -->
  <app-navbar></app-navbar>
</header>
<!--/.Navbar-->

<!--Sidebar-->
<app-sidebar></app-sidebar>

<!--Main Content Area-->
<main class="pmd-content home-layout" aria-label="Main Content" id="mainContent">
  <router-outlet></router-outlet>
</main>

<footer aria-label="Footer">
  <app-footer class="web-app-footer" aria-label="Footer"></app-footer>
</footer>
<!--/.Main Content Area-->
